import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../client.js';

const KEY = (pid: string) => ['projects', pid, 'risiken'] as const;

export function useRisiken(projectId: string | undefined) {
  return useQuery({
    queryKey: KEY(projectId ?? ''),
    queryFn: () => apiClient.get(`/api/v1/projects/${projectId}/risiken`),
    enabled: !!projectId,
  });
}

export function useCreateRisiko(pid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Record<string, unknown>) => apiClient.post(`/api/v1/projects/${pid}/risiken`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(pid) }),
  });
}

export function useUpdateRisiko(pid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Record<string, unknown> }) =>
      apiClient.patch(`/api/v1/projects/${pid}/risiken/${id}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(pid) }),
  });
}

export function useDeleteRisiko(pid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiClient.delete(`/api/v1/projects/${pid}/risiken/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(pid) }),
  });
}
